__webpack_require__.p = "/programowanie/hanoi/";